document.addEventListener('DOMContentLoaded', function () {
  var menuButton = document.querySelector('[data-menu-toggle]');
  var menu = document.querySelector('[data-mobile-menu]');
  if (menuButton && menu) {
    menuButton.addEventListener('click', function () {
      var open = menuButton.getAttribute('aria-expanded') === 'true';
      menuButton.setAttribute('aria-expanded', String(!open));
      menu.hidden = open;
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !menu.hidden) {
        menu.hidden = true;
        menuButton.setAttribute('aria-expanded', 'false');
        menuButton.focus();
      }
    });
  }

  document.querySelectorAll('.pw-buybar-form input[name="id"]').forEach(function (radio) {
    radio.addEventListener('change', function () {
      var price = document.querySelector('[data-product-price]');
      if (price && radio.dataset.price) price.textContent = radio.dataset.price;
    });
  });

  var articleNav = document.querySelector('.article-nav');
  if (articleNav) {
    var articleNavFrame = 0;
    function updateArticleNavState() {
      articleNavFrame = 0;
      var headerHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--nav-h')) || 0;
      document.documentElement.classList.toggle('article-nav-stuck', articleNav.getBoundingClientRect().top <= headerHeight + 0.5);
    }
    window.addEventListener('scroll', function () {
      if (articleNavFrame) return;
      articleNavFrame = requestAnimationFrame(updateArticleNavState);
    }, {passive: true});
    window.addEventListener('resize', updateArticleNavState, {passive: true});
    updateArticleNavState();
  }

  var gallery = document.querySelector('[data-pw-gallery]');
  var stage = document.querySelector('[data-pw-stage]');
  var progress = document.querySelector('[data-pw-progress]');
  if (!gallery || !stage) return;

  var desktop = window.matchMedia('(min-width: 990px)');
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var pendingFrame = 0;

  function measureGallery() {
    if (!desktop.matches) {
      stage.style.height = '';
      stage.classList.remove('is-active');
      gallery.scrollLeft = 0;
      return;
    }
    var horizontalDistance = Math.max(0, gallery.scrollWidth - gallery.clientWidth);
    stage.style.height = Math.ceil(gallery.clientHeight + horizontalDistance) + 'px';
    updateGalleryFromPage();
  }

  function updateGalleryFromPage() {
    pendingFrame = 0;
    if (!desktop.matches) return;
    var horizontalDistance = Math.max(1, gallery.scrollWidth - gallery.clientWidth);
    var verticalDistance = Math.max(1, stage.offsetHeight - gallery.clientHeight);
    var stageTop = stage.getBoundingClientRect().top + window.scrollY;
    var ratio = Math.min(1, Math.max(0, (window.scrollY - stageTop) / verticalDistance));
    gallery.scrollLeft = horizontalDistance * ratio;
    stage.classList.toggle('is-active', window.scrollY >= stageTop && window.scrollY <= stageTop + verticalDistance);
    if (progress) {
      var track = progress.parentElement.clientHeight - progress.clientHeight;
      progress.style.transform = 'translateY(' + Math.round(track * ratio) + 'px)';
    }
  }

  window.addEventListener('scroll', function () {
    if (pendingFrame) return;
    pendingFrame = requestAnimationFrame(updateGalleryFromPage);
  }, {passive: true});
  window.addEventListener('resize', measureGallery, {passive: true});
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(measureGallery);
  measureGallery();

  gallery.addEventListener('keydown', function (event) {
    if (!desktop.matches || (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight')) return;
    event.preventDefault();
    window.scrollBy({top: event.key === 'ArrowRight' ? 300 : -300, behavior: reduced.matches ? 'auto' : 'smooth'});
  });
});
